import {TALK_VERSION} from '@zzng/common/constants/talkVersion';
import {isUnderTalkVersion, isValidTalkVersion, kakaoTalkVersion} from '@zzng/common/utils/agent';

export const isRequiredKakaoTalkVersion = isValidTalkVersion(kakaoTalkVersion, TALK_VERSION['11.2.0']);
export const isUnderKakaoTalkVersion = isUnderTalkVersion(kakaoTalkVersion, TALK_VERSION['11.2.0']);
